import React, { useEffect, useState } from "react";
import { Col, ConfigProvider, DatePicker, Row, Table } from "antd";
import Input from "../../../../components/Input/Input";
import { DownOutlined, SearchOutlined, UnorderedListOutlined } from "@ant-design/icons";
import Text from "../../../../components/Text/Text";
import { FlexCol } from "../../../../components/Container/Container";
import { numberFormatter } from "../../../../utility/Formatter";
import Permission from "../../../../components/Permission/Permission";
import { ActionBtn } from "../../../../components/Button/TableActionButton";
import Select from "../../../../components/Select/Select";
import { color, icon } from "../../../../resource";
import Button from "../../../../components/Button/Button";

export const HistoryPointTab = ({
  data,
  page,
  pageSize,
  setPage,
  setPageSize,
}: {
  data: any;
  page?: string;
  pageSize?: string;
  setPage?: any;
  setPageSize?: any;
}) => {
  const { companyType } = JSON.parse(localStorage.getItem("company")!);

  const columns = [
    {
      title: "วันที่และเวลา",
      dataIndex: "dateTime",
      key: "dateTime",
    },
    {
      title: companyType === "Fertilizer" ? "ร้าน Sub-Dealer" : "ร้าน Dealer",
      dataIndex: "shopName",
      key: "shopName",
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "รายการอ้างอิง",
      dataIndex: "reference",
      key: "reference",
    },
    {
      title: "แต้ม",
      dataIndex: "points",
      key: "points",
    },
    {
      title: "ผู้ดำเนินรายการ",
      dataIndex: "operator",
      key: "operator",
    },
  ];

  return (
    <>
      <Row justify='start' gutter={8}>
        <Col span={6}>
          <Input
            autoComplete='off'
            placeholder={
              companyType === "Fertilizer" ? "รหัส / ชื่อร้าน Sub-Dealer" : "รหัส / ชื่อร้าน Dealer"
            }
            suffix={<SearchOutlined />}
          />
        </Col>
        <Col span={3}>
          <Select data={[]} placeholder='เลือกเขต' />
        </Col>
        <Col span={5}>
          <Select data={[]} placeholder='สถานะทั้งหมด' />
        </Col>
        <Col span={2} />
        <Col>
          <DatePicker.RangePicker
            format='DD/MM/YYYY'
            allowClear={false}
            allowEmpty={[true, true]}
            style={{ width: "100%", color: color.BK, height: "40px" }}
            //value={[period[0] ? dayjs(period[0]) : null, period[1] ? dayjs(period[1]) : null]}
          />
        </Col>
        <Col>
          <Button
            title='ดาวน์โหลด'
            icon={<img src={icon.downloadFileIcon} style={{ width: 18, height: 18 }} />}
            typeButton='primary-light'
          />
        </Col>
      </Row>
      <br />
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
            },
          },
        }}
      >
        <Table
          columns={columns}
          dataSource={data?.data}
          scroll={{ x: "max-content" }}
          pagination={{
            pageSize: Number(pageSize) || 10,
            current: Number(page) || 1,
            total: data?.count || 0,
            showSizeChanger: false,
            position: ["bottomCenter"],
            onChange: (page, size: any) => {
              const nextPage = String(page);
              setPage(nextPage);
              setPageSize(size);
            },
          }}
        />
      </ConfigProvider>
    </>
  );
};
